<div *ngIf="IbGiftCardsContributionService.contributionDataResponse && IbGiftCardsContributionService.availabilityDataResponse" class="ib-gift-cards">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="ib-layout__header ib-layout__header--title">
                    <h1 class="ib-heading ib-heading--type-1 ib-gift-cards__heading">{{"GIFT_CARD_MAIN_TITLE" | translate: { cardName: IbGiftCardsContributionService.contributionDataResponse.giftCardName} }}</h1>
                </div>
            </div>
        </div>
        <div *ngIf="IbGiftCardsContributionService.availabilityDataResponse.flowId">
            <ib-gift-cards-new-contribution-form></ib-gift-cards-new-contribution-form>
        </div>
        <!-- <ib-gift-cards-configuration-contribution-form model="giftCardsConfigurationContributionCtrl.model">
        </ib-gift-cards-configuration-contribution-form> -->
    </div>
</div>
